import React from 'react'
import '../styles/vision.css'

/* Vision in Home page */

function Vision() {
  return (
    <div className="w-[90%] m-auto p-2 mt-[50px] mx-auto hello">
    <div className="two">
  <h1>Vision
    <span>We Rise by Lifting Others</span>
  </h1>
</div>

    <div>
        <p className='text-left mt-[40px]'>
            ACM is an international student chapter that brings together technology geeks, computer educators, working professionals, among others and gives them a platform to share all things related to the world of rapidly evolving technology. ACM has always been at the forefront of raising awareness about new technologies, educating people and empowering them to do something new.
            Apart from being a technological learning and skill sharing platform, ACM is also renowned for developing in its members a sense of teamwork and dedication. It empowers individuals to scale new heights in their professional careers.
            <br/>With more than 100,000 members worldwide, the fraternity only continues to grow stronger in every passing year. A chapter with such illustrious history, finds its place with a great prominence in VNRVJIET. The team running the chapter constantly strives to bring about awareness and widen the reach of technology and its wonders to more and more people.
        </p>
    </div>
</div>

  )
}

export default Vision